// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { sectionSubTitleStyle } from "@mcmc/XDL/Utilities/sharedStyles";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    title: string;
    value?: string | undefined;
}

export interface OrderConfirmationSingleDetailStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
}

export const orderConfirmationSingleDetailStyles: OrderConfirmationSingleDetailStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
        `,
    },
    titleText: sectionSubTitleStyle,
};

type Props = OwnProps;

const styles = orderConfirmationSingleDetailStyles;
const OrderConfirmationSingleDetail: FC<Props> = props => {
    const { title, value, children } = props;

    if (!value && !children) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{title}</Typography>
            {value && <Typography>{value}</Typography>}
            {children}
        </StyledWrapper>
    );
};

export default OrderConfirmationSingleDetail;
